class TabNavigation {
    constructor(linkList) {
        this.window = window;
        this.location = this.window.location;
        this.linkList = linkList;
        this.anchorLinks = null;
        this.anchorTarget = null;
        this.header = document.querySelector('.js-header');

        this.init();
    }

    set links(linkNodeList) {
        this.anchorLinks = Array.from(linkNodeList);
    }

    get links() {
        return this.anchorLinks;
    }

    set linkTarget(baseElement) {
        this.anchor = baseElement.getAttribute('href')
            .slice(1);
        this.anchorTarget = document.getElementById(this.anchor);
    }

    get linkTarget() {
        return this.anchorTarget;
    }

    init() {
        this.links = this.linkList;
        this.scrollByHash();
        this.registerEvents();
    }

    pageYOffset(offset) {
        const currentScrollPosition = this.window.pageYOffset;

        return (currentScrollPosition > 0 && currentScrollPosition >= offset)
            ? currentScrollPosition - offset
            : currentScrollPosition;
    }

    scrollToElement(target = null, offset = 0) {
        const elementPosition = target.getBoundingClientRect().top;
        let offsetPosition = (elementPosition - offset);

        if (!offsetPosition) return;

        offsetPosition += this.pageYOffset(offset);

        this.window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    }

    toggleActiveLink(currentTarget) {
        this.links.map((link) => link.classList.remove('active'));
        currentTarget.classList.add('active');
    }

    getCurrentHeaderHeight() {
        return this.header.offsetHeight;
    }

    scrollByHash() {
        if (!this.location.hash.length) return;

        const currentTarget = this.links.find((link) => link.getAttribute('href') === this.location.hash);
        this.linkTarget = currentTarget;

        this.scrollToElement(this.linkTarget, this.getCurrentHeaderHeight());
        this.toggleActiveLink(currentTarget);
    }

    registerEvents() {
        this.links.forEach((linkElement) => {
            linkElement.addEventListener('click', (event) => {
                event.preventDefault();

                const {currentTarget} = event;
                this.linkTarget = currentTarget;

                this.window.history.pushState(null, 'anchor', `#${this.anchor}`);

                this.scrollToElement(this.linkTarget, this.getCurrentHeaderHeight());
                this.toggleActiveLink(currentTarget);
            });
        });
    }
}

const tabNavigation = {
    init() {
        const linkList = document.querySelectorAll('.js-tab-navigation-link');

        if (!linkList.length) return;

        this.tabs = new TabNavigation(linkList);
    },
};

export default tabNavigation;
